<template>
    <SOSlotModal  
        modal-title="Verifikasi WA"
        :modal-id="id"
        :no-padding="true"
        @close="decline()"
    >
        <template v-slot:modal-body>
            <div class="p-4">
                <div class="d-flex align-items-baseline">
                    <SOInputOnOff
                        class="m-d-20"
                        :checkboxes="waVerif"
                        :checked="isChecked"
                        @selected="v => isChecked = v"
                    />
                    <div>
                        <div class="f-16 f-c-primary">
                            Verifikasi WA aktif
                        </div>
                        <div class="f-14 f-c-midgrey">
                            Kode OTP dikirimkan ke WA konsumen untuk pendaftaran member
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template v-slot:modal-footer>
            <div id="button" class="px-4 pb-2">
                <SOButton
                    text="Simpan"
                    primary
                    :disable="disable"
                    :loading="isLoading"
                    :full="true"
                    @action="onSave()"
                />
            </div>
        </template>
    </SOSlotModal>
</template>

<script>
import SOSlotModal from "@/so-components/global/slot/SOSlotModal";
import SOButton from "@/so-components/global/ui/SOButton";
import SOInputOnOff from "@/so-components/global/input/SOInputOnOff.vue";
import { mapActions } from 'vuex';
import { moduleName } from "../../store/state";

export default {
    name: "ModalWaVerificationSetting",
    components: {
        SOSlotModal,
        SOButton,
        SOInputOnOff,
    },  
    data () {
        return {
            id:"ModalWaVerificationSetting",
            resolve: null,
            waVerif: {
                data: [
                    {
                        id: "rem-1",
                        value: "1",
                        // title: "Verifikasi WA tidak aktif",
                        checked: false,
                        titleBold: false,
                    },
                ],
            },
            isChecked: false,
            oldValue: null,
            isLoading: false
        }
    },
    methods: {
        ...mapActions(moduleName, {
            updateWaVerification: 'updateWaVerification',
        }),
        open(value) {
            this.isChecked = value
            this.oldValue = this.isChecked
            this.isLoading = false
            return new Promise((resolve)=>{
                this.resolve = resolve
                $("#" + this.id).modal("show");
            })
        },
        confirm() {
            this.resolve(true)
        },
        decline() {
            this.resolve(false)
            this.close();
        },
        close() {
            $("#" + this.id).modal("hide");
            setTimeout(() => {
                this.$emit("close");
            }, 500);
        },
        onSave() {
            this.isLoading = true
            this.updateWaVerification(this.isChecked)
                .then((r) => {
                    if (r.success) {
                        this.confirm()
                        return
                    }
                    this.isLoading = false
                    this.$toast.error(r.err)
                })
                .catch((e) => {
                    this.$toast.error(e)
                    console.log(e)
                })
        }
    },
    computed: {
        disable() {
            return this.loading || (this.oldValue == this.isChecked)
        }
    }
}
</script>

<style scoped>
#button >>> .btn-outline-danger{
    margin-bottom: 1rem
}
</style>